export const ROLE_ADMIN = 'admin';
export const ROLE_SUPER_ADMIN = 'super_admin';
export const ROLE_CREATOR = 'creator';
export const ROLE_EDITOR = 'editor';
export const ROLE_SUPPORT = 'support';
export const ROLE_RECEIVER = 'receiver';
